export default {
  siteName: "USFansSheet",
  navHome: "Accueil",
  navShoppingGuide: "Guide d'achat",
  navSpreadsheet: "Feuille",
  navCategories: "Catégories",
  navGuides: "Guides",
  navFAQ: "FAQ",
  ctaExplore: "Explorer la feuille",
  ctaBuyNow: "Acheter maintenant",
  ctaMainSite: "Visiter le site principal",
  dropdownLabel: "Parcourir les catégories",
  dropdownPlaceholder: "Choisir une catégorie…",
  footerTagline:
    "Un centre de ressources indépendant pour USFans Spreadsheet — pour découvrir des trouvailles, comparer les options et acheter plus malin.",
  footerQuickLinks: "Liens rapides",
  footerCategories: "Catégories",
  footerLegal: "Mentions légales",
  footerHome: "Accueil",
  footerGuide: "Guide USFans Spreadsheet",
  footerAbout: "À propos",
  footerContact: "Contact",
  footerPrivacy: "Politique de confidentialité",
  footerDisclaimer: "Avertissement",
  footerAffiliate: "Divulgation d'affiliation",
  externalNote: "Les liens externes s'ouvrent dans un nouvel onglet.",
  copyright: "USFansSheet. Tous droits réservés.",
  notFoundTitle: "Page introuvable",
  notFoundDesc: "La page que vous cherchez n'existe pas ou a été déplacée. Revenez à l'accueil pour continuer.",
  notFoundCta: "Retour à l'accueil",
  disclaimer:
    "USFansSheet est une ressource d'information indépendante, non affiliée à USFans, non approuvée par lui et qui n'est pas son site officiel. Tous les liens produits redirigent vers des sites tiers.",
  categories: {
    shoes: "Chaussures",
    hoodiesSweaters: "Sweats / Pulls",
    tShirts: "T-shirts",
    jackets: "Vestes",
    pantsShorts: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements / Caleçons",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    otherStuff: "Autres articles",
  },
};